import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { ThinLayoutComponent } from './thin.component';
import { CalsoftNavigationModule } from 'src/app/global/components/navigation';
import { MessagesModule } from 'src/app/layout/common/messages/messages.module';
import { NotificationsModule } from 'src/app/layout/common/notifications/notifications.module';
import { SearchModule } from 'src/app/layout/common/search/search.module';
import { ShortcutsModule } from 'src/app/layout/common/shortcuts/shortcuts.module';
import { UserModule } from 'src/app/layout/common/user/user.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatSelectModule } from '@angular/material/select';
import { CustomFlexLayoutModule } from 'src/app/shared/flex-layout/custom-flex-layout.module';
import { CrmSearchModule } from 'src/app/shared/crm-search/crm-search.module';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { HeaderUserModule } from 'src/app/layout/common/header-user/header-user.module';

@NgModule({
    declarations: [
        ThinLayoutComponent
    ],
    imports: [
        HttpClientModule,
        RouterModule,
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatMenuModule,
        CalsoftNavigationModule,
        MessagesModule,
        NotificationsModule,
        SearchModule,
        ShortcutsModule,
        UserModule,
        SharedModule,
        CustomFlexLayoutModule,
        CrmSearchModule,
        MatSelectModule,
        MatAutocompleteModule,
        HeaderUserModule
    ],
    exports: [
        ThinLayoutComponent
    ]
})
export class ThinLayoutModule {
}
